import { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarBlank } from "@phosphor-icons/react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

export const DatePicker = ({ value, onChange, placeholder = "Select date", testId, disabled }) => {
  const [open, setOpen] = useState(false);
  let selected;
  try { selected = value ? parseISO(value) : undefined; } catch { selected = undefined; }

  const handleSelect = (date) => {
    if (!date) return;
    onChange(format(date, "yyyy-MM-dd"));
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={disabled ? undefined : setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          disabled={disabled}
          className="w-full h-9 px-3 flex items-center justify-between border border-border bg-background text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-muted transition-colors"
          style={{ borderRadius: "2px" }}
        >
          <span className={selected ? "" : "text-muted-foreground"}>{selected ? format(selected, "d MMM yyyy") : placeholder}</span>
          <CalendarBlank size={15} className="text-muted-foreground" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" style={{ borderRadius: "2px" }}>
        <Calendar mode="single" selected={selected} onSelect={handleSelect} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
